import AssessmentQuestionnairesContainer from './AssessmentQuestionnairesContainer'
export default AssessmentQuestionnairesContainer
